import * as type from './mutation-types'
import * as API from './api'
import { ajax } from '@/utils/fetch'

// 用户信息
export const thirdPayLogin = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.THIRDPAYLOGIN_REQUEST, data)
        // http 请求
    return ajax.upload(
        API.thirdPayLogin, {
            commit
        },
        data,
        type.THIRDPAYLOGIN_RECEIVE
    )
};

// 币种和档位映射关系
export const getCurrencyGear = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETCURRENCYGEAR_REQUEST, data)
        // http 请求
    return ajax.getPay(
        API.getCurrencyGear, {
            commit
        },
        data,
        type.GETCURRENCYGEAR_RECEIVE
    )
};

// 支付方式列表获取
export const getAllPayMode = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETALLPAYMODE_REQUEST, data)
        // http 请求
    return ajax.getPay(
        API.getAllPayMode, {
            commit
        },
        data,
        type.GETALLPAYMODE_RECEIVE
    )
};

// 三方支付商品列表获取
export const serverIapList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SERVERIAPLIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.serverIapList, {
            commit
        },
        data,
        type.SERVERIAPLIST_RECEIVE
    )
};

// 三方支付消费记录
export const getThirdPayOrderList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETTHIRDPAYORDERLIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getThirdPayOrderList, {
            commit
        },
        data,
        type.GETTHIRDPAYORDERLIST_RECEIVE
    )
};

// 创建三方支付订单
export const createThirdPayOrder = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CREATETHIRDPAYORDER_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.createThirdPayOrder, {
            commit
        },
        data,
        type.CREATETHIRDPAYORDER_RECEIVE
    )
};

// 三方订单校验
export const verifyThirdPayOrder = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.VERIFYTHIRDPAYORDER_REQUEST, data)
        // http 请求
    return ajax.post(
        API.verifyThirdPayOrder, {
            commit
        },
        data,
        type.VERIFYTHIRDPAYORDER_RECEIVE
    )
};

// 执行请款
export const thirdPayOrderRequestPay = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.THIRDPAYORDERREQUESTPAY_REQUEST, data)
        // http 请求
    return ajax.post(
        API.thirdPayOrderRequestPay, {
            commit
        },
        data,
        type.THIRDPAYORDERREQUESTPAY_RECEIVE
    )
};

// 获取游戏角色上一次支付成功的支付方式
export const getDefaultPayment = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETDEFAULTPAYMENT_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getDefaultPayment, {
            commit
        },
        data,
        type.GETDEFAULTPAYMENT_RECEIVE
    )
};

// 基于 token 列表检验合法角色 token
export const checkRolesToken = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHECKROLESTOKEN_REQUEST, data)
        // http 请求
    return ajax.post(
        API.checkRolesToken, {
            commit
        },
        data,
        type.CHECKROLESTOKEN_RECEIVE
    )
};

// 三方支付查询子订单
export const orderSublist = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.ORDERSUBLIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.orderSublist, {
            commit
        },
        data,
        type.ORDERSUBLIST_RECEIVE
    )
};

// 三方商城获取用户 礼金 剩余数
export const getUserPointData = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERPOINTDATA_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getUserPointData, {
            commit
        },
        data,
        type.GETUSERPOINTDATA_RECEIVE
    )
};

// 三方商城获取 礼金 使用规则说明
export const getUserPointRule = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERPOINTRULE_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getUserPointRule, {
            commit
        },
        data,
        type.GETUSERPOINTRULE_RECEIVE
    )
};

// 三方商城获取 礼金 使用规则开关
export const getUserPointSwitch = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERPOINTSWITCH_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getUserPointSwitch, {
            commit
        },
        data,
        type.GETUSERPOINTSWITCH_RECEIVE
    )
};

// 三方商城获取邮箱验证码
export const getEmailCode = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETEMAILCODE_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getEmailCode, {
            commit
        },
        data,
        type.GETEMAILCODE_RECEIVE
    )
};

// 三方商城设置三方支付安全邮箱
export const setPayEmail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SETPAYEMAIL_REQUEST, data)
        // http 请求
    return ajax.post(
        API.setPayEmail, {
            commit
        },
        data,
        type.SETPAYEMAIL_RECEIVE
    )
};

// 三方商城校验用户是否为首次支付
export const getPointInit = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPOINTINIT_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getPointInit, {
            commit
        },
        data,
        type.GETPOINTINIT_RECEIVE
    )
};

// 三方商城校验用户是否已经设置支付密码
export const getPayPwdFlag = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPAYPWDFLAG_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getPayPwdFlag, {
            commit
        },
        data,
        type.GETPAYPWDFLAG_RECEIVE
    )
};

// 三方商城校验用户是否设置安全邮箱
export const getEmailFlag = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETEMAILFLAG_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getEmailFlag, {
            commit
        },
        data,
        type.GETEMAILFLAG_RECEIVE
    )
};

// 三方商城设置三方支付支付密码
export const setPayPwd = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SETPAYPWD_REQUEST, data)
        // http 请求
    return ajax.post(
        API.setPayPwd, {
            commit
        },
        data,
        type.SETPAYPWD_RECEIVE
    )
};

// 三方商城修改三方支付支付密码
export const changePayPwd = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHANGEPAYPWD_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.changePayPwd, {
            commit
        },
        data,
        type.CHANGEPAYPWD_RECEIVE
    )
};

// 查询三方支付安全邮箱地址
export const getUserPayEmail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERPAYEMAIL_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getUserPayEmail, {
            commit
        },
        data,
        type.GETUSERPAYEMAIL_RECEIVE
    )
};

// 三方商城修改密码时校验支付旧密码
export const checkPayPwd = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHECKPAYPWD_REQUEST, data)
        // http 请求
    return ajax.getPay(
        API.checkPayPwd, {
            commit
        },
        data,
        type.CHECKPAYPWD_RECEIVE
    )
};

// 三方商城修改密码时校验支付旧密码
export const checkPayEmail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHECKPAYEMAIL_REQUEST, data)
        // http 请求
    return ajax.getPay(
        API.checkPayEmail, {
            commit
        },
        data,
        type.CHECKPAYEMAIL_RECEIVE
    )
};

//版本号查询
export const getVersion = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETVERSION_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getVersion, {
            commit
        },
        data,
        type.GETVERSION_RECEIVE
    )
};

//PC 海外商城获取玩家登录信息
export const getPCInfo = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPCINFO_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getPCInfo, {
            commit
        },
        data,
        type.GETPCINFO_RECEIVE
    )
};

//PC 版商城根据网络环境查询解析国家信息
export const getPCCountry = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPCCOUNTRY_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getPCCountry, {
            commit
        },
        data,
        type.GETPCCOUNTRY_RECEIVE
    )
};

//PC 版商城查询国家列表
export const getPCAllCountry = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPCALLCOUNTRY_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getPCAllCountry, {
            commit
        },
        data,
        type.GETPCALLCOUNTRY_RECEIVE
    )
};

//PC 版支付金额/国家等查询可用支付方式
export const getPCPayM = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPCPAYM_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.getPCPayM, {
            commit
        },
        data,
        type.GETPCPAYM_RECEIVE
    )
};

//PC 版币种和档位映射关系
export const getPCGear = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPCGEAR_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getPCGear, {
            commit
        },
        data,
        type.GETPCGEAR_RECEIVE
    )
};

//PC 查询所有币种和符号的映射关系
export const getAllGear = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETALLGEAR_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getAllGear, {
            commit
        },
        data,
        type.GETALLGEAR_RECEIVE
    )
};

//Web 官网商城查询地区列表
export const getWebRegion = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETWEBREGION_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getWebRegion, {
            commit
        },
        data,
        type.GETWEBREGION_RECEIVE
    )
};
//Web 官网查询应用基础数据
export const getWebAppInfo = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETWEBAPPINFO_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getWebAppInfo, {
            commit
        },
        data,
        type.GETWEBAPPINFO_RECEIVE
    )
};
//Web 官网商城查询用户所在地区支付方式
export const getWebPayMode = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETWEBPAYMODE_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getWebPayMode, {
            commit
        },
        data,
        type.GETWEBPAYMODE_RECEIVE
    )
};
//Web 官网商城查询未登录商品列表
export const getWebUnLoadGoods = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETWEBUNLOADGOODS_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getWebUnLoadGoods, {
            commit
        },
        data,
        type.GETWEBUNLOADGOODS_RECEIVE
    )
};
//Web 官网查询应用开关
export const getWebSwitch = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETWEBSWITCH_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getWebSwitch, {
            commit
        },
        data,
        type.GETWEBSWITCH_RECEIVE
    )
};
//Web 官网登录 - NT 登录
export const getNtLogin = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETNTLOGIN_REQUEST, data)
        // http 请求
    return ajax.upload(
        API.getNtLogin, {
            commit
        },
        data,
        type.GETNTLOGIN_RECEIVE
    )
};
//Web 官网扫码登录查询鉴权数据
export const getScanLogin = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETSCANLOGIN_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getScanLogin, {
            commit
        },
        data,
        type.GETSCANLOGIN_RECEIVE
    )
};
//PC 扫码登陆生成唯一码
export const getGeneCode = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETGENECODE_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getGeneCode, {
            commit
        },
        data,
        type.GETGENECODE_RECEIVE
    )
};
//PC 监听获取账号扫码登陆状态
export const getGeneInfo = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETGENEINFO_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getGeneInfo, {
            commit
        },
        data,
        type.GETGENEINFO_RECEIVE
    )
};
//Web 官网商城查询平台账号下的所有角色信息
export const getWebRoleList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETWEBROLELIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getWebRoleList, {
            commit
        },
        data,
        type.GETWEBROLELIST_RECEIVE
    )
};
//Web 官网获取商城角色鉴权身份数据
export const getMallLoginStatus = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.getMallLoginStatus_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.getMallLoginStatus, {
            commit
        },
        data,
        type.getMallLoginStatus_RECEIVE
    )
};
//Web 官网退出账号登陆
export const getWebLogout = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETWEBLOGOUT_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getWebLogout, {
            commit
        },
        data,
        type.GETWEBLOGOUT_RECEIVE
    )
};
//Web code码登陆
export const getCodeLogin = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETCODELOGIN_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getCodeLogin, {
            commit
        },
        data,
        type.GETCODELOGIN_RECEIVE
    )
};
//Web vk渠道获取重定向参数
export const getVKParams = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETVKPARAMS_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getVKParams, {
            commit
        },
        data,
        type.GETVKPARAMS_RECEIVE
    )
};
//Web vk渠道码登陆
export const getVKCodeLogin = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETVKCODELOGIN_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getVKCodeLogin, {
            commit
        },
        data,
        type.GETVKCODELOGIN_RECEIVE
    )
};